module.exports = __webpack_public_path__ + "static/media/22.9d630633.mp3";